import type { SupplierDirectoryListItem } from '@tandemone/types'
import type { ColumnDef, OnChangeFn, SortingState } from '@tanstack/react-table'

import { DataTable } from '@/components/ui/data-table'
import { DataTablePagination } from '@/components/ui/data-table-pagination'
import { Skeleton } from '@/components/ui/skeleton'

import { SupplierDirectoryMobileList } from './mobile-list'

type Props = {
  isLoading: boolean
  isError: boolean
  items: SupplierDirectoryListItem[]
  total: number
  page: number
  pageSize: number
  onPageChange: (page: number) => void
  onPageSizeChange: (pageSize: number) => void
  sorting: SortingState
  onSortingChange: OnChangeFn<SortingState>
  columns: ColumnDef<SupplierDirectoryListItem>[]
  rowHref: (item: SupplierDirectoryListItem) => string
  rowLinkState?: unknown
  emptyMessage: string
  showFavorite?: boolean
}

export function SupplierDirectoryResults({
  isLoading,
  isError,
  items,
  total,
  page,
  pageSize,
  onPageChange,
  onPageSizeChange,
  sorting,
  onSortingChange,
  columns,
  rowHref,
  rowLinkState,
  emptyMessage,
  showFavorite
}: Props) {
  if (isLoading) {
    return (
      <div className='flex flex-col gap-2'>
        <Skeleton className='h-10 w-full' />
        <Skeleton className='h-10 w-full' />
        <Skeleton className='h-10 w-full' />
      </div>
    )
  }
  if (isError) {
    return (
      <div className='rounded-md border border-destructive/40 bg-destructive/5 p-4 text-sm text-destructive'>
        Failed to load suppliers. Try refreshing.
      </div>
    )
  }
  return (
    <>
      <DataTable
        columns={columns}
        data={items}
        getRowHref={rowHref}
        rowLinkState={rowLinkState}
        emptyMessage={emptyMessage}
        sorting={sorting}
        onSortingChange={onSortingChange}
      />
      <SupplierDirectoryMobileList
        items={items}
        emptyMessage={emptyMessage}
        rowHref={rowHref}
        rowLinkState={rowLinkState}
        showFavorite={showFavorite}
      />
      <DataTablePagination
        page={page}
        pageSize={pageSize}
        total={total}
        onPageChange={onPageChange}
        onPageSizeChange={onPageSizeChange}
      />
    </>
  )
}
